<template>
  <div>
    <div>
      <form id="create-clip" role="form"
            method="post"
            :action="'clip/store'" @submit.prevent="createClip">
        <div class="form-body">
          <div class="row">
            <div class="col-12">
              <div class="alert alert-grey" role="alert">
                Clips are temporary and will be kept for a maximum of 7 days. If you wish for a clip to become permanent move it to storage.
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="row">
                <div class="col-12 col-md-6 time-input">
                  <label class="control-label">Begin Clip At</label>
                  <div class="input-group kt-input-group kt-input-group--square">
                    <div class="input-group-prepend">
                      <span id="begin-group" class="input-group-text"><i class="fa fa-clock time" /></span>
                    </div>
                    <input
                      id="from-time"
                      v-model="from"
                      v-validate="'is_time|within_duration|required'"
                      v-mask="'##:##:##'"
                      name="from-time"
                      type="text"
                      class="form-control time kt-input"
                      placeholder="00:00:00">
                  </div>
                  <span v-show="errors.has('from-time')" class="text-ss-danger">{{ errors.first('from-time') }}</span>
                </div>
                <div class="col-12 col-md-6 time-input">
                  <label class="control-label">End Clip At</label>
                  <div class="input-group kt-input-group kt-input-group--square">
                    <div class="input-group-prepend">
                      <span id="end-group" class="input-group-text"><i class="fa fa-clock time" /></span>
                    </div>
                    <input
                      id="to-time"
                      v-model="to"
                      v-validate="'is_time|within_duration|greater_than_from|required'"
                      v-mask="'##:##:##'"
                      name="to-time"
                      type="text"
                      class="form-control time kt-input"
                      placeholder="00:00:00">
                  </div>
                  <span v-show="errors.has('to-time')" class="text-ss-danger">{{ errors.first('to-time') }}</span>
                </div>

                <div class="col-12 col-md-6 time-input">
                  <label class="control-label">Silence Before</label>
                  <div class="input-group kt-input-group kt-input-group--square">
                    <div class="input-group-prepend">
                      <span id="before-group" class="input-group-text"><i class="fa fa-clock time" /></span>
                    </div>
                    <input
                      id="silence-before"
                      v-model="silenceBefore"
                      v-validate="'is_time'"
                      v-mask="'##:##:##'"
                      name="silence-before"
                      type="text"
                      class="form-control time kt-input"
                      placeholder="00:00:00">
                  </div>
                  <span v-show="errors.has('silence-before')" class="text-ss-danger">{{ errors.first('silence-before') }}</span>
                </div>
                <div class="col-12 col-md-6 time-input">
                  <label class="control-label">Silence After</label>
                  <div class="input-group kt-input-group kt-input-group--square">
                    <div class="input-group-prepend">
                      <span id="after-group" class="input-group-text"><i class="fa fa-clock time" /></span>
                    </div>
                    <input
                      id="silence-after"
                      v-model="silenceAfter"
                      v-validate="'is_time'"
                      v-mask="'##:##:##'"
                      name="silence-after"
                      type="text"
                      class="form-control time kt-input"
                      placeholder="00:00:00">
                  </div>
                  <span v-show="errors.has('silence-after')" class="text-ss-danger">{{ errors.first('silence-after') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <button type="button" class="btn-clip-create btn btn-ss-standout mt-ladda-btn ladda-button"
                      data-style="expand-right"
                      @click.prevent="createClip">
                <span class="ladda-label">Create Clip</span>
              </button>
            </div>
          </div>
        </div>
      </form>

      <div class="clip-table">
        <clips-table v-if="item && item.uuid" :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
import VeeValidate from "vee-validate";
import VueTheMask from "vue-the-mask";
import Ladda from "ladda";
import "ladda/dist/ladda-themeless.min.css";
import ClipsTable from "VuePartials/App/Ffmpeg/Table/ClipsTable";

Vue.use(VueTheMask);
Vue.use(VeeValidate, { fieldsBagName: "formFields" });

export default {
  name: "StorageEdit",
  components: {
    ClipsTable,
  },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  data: () => ({
    from: "00:00:00",
    to: "00:00:00",
    silenceBefore: "00:00:00",
    silenceAfter: "00:00:00",
    submitLadda: null,
  }),
  computed: {
    ffmpegData() {
      return this.item.ffmpeg_details;
    },
    fromInSeconds() {
      return this.convertToSeconds(this.from);
    },
    toInSeconds() {
      return this.convertToSeconds(this.to);
    },
    silenceBeforeInSeconds() {
      return this.convertToSeconds(this.silenceBefore);
    },
    silenceAfterInSeconds() {
      return this.convertToSeconds(this.silenceAfter);
    },
    duration() {
      if (this.ffmpegData && this.ffmpegData.duration) {
        return this.ffmpegData.duration;
      }

      return 0;
    },
  },
  created() {
    VeeValidate.Validator.extend("within_duration", {
      // Custom validation message
      getMessage: () => `Value exceeds duration`,
      // Custom validation rule
      validate: value =>
        new Promise((resolve) => {
          const a = value.split(":"); // split it at the colons
          // minutes are worth 60 seconds. Hours are worth 60 minutes.
          const value_in_seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];

          resolve({
            valid: value && value_in_seconds < this.duration,
          });
        }),
    });

    VeeValidate.Validator.extend("greater_than_from", {
      getMessage: () => `'To' must be after 'From'`,
      validate: () =>
        new Promise((resolve) => {
          const to_seconds = this.convertToSeconds(this.to);
          const from_seconds = this.convertToSeconds(this.from);

          resolve({
            valid: to_seconds >= from_seconds,
          });
        }),
    });
  },
  methods: {
    convertToSeconds(time) {
      const a = time.split(":"); // split it at the colons
      // minutes are worth 60 seconds. Hours are worth 60 minutes.
      return +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
    },
    createClip() {
      const form_data = {
        from: this.fromInSeconds,
        to: this.toInSeconds,
        storage_id: this.item.uuid,
        silence_before: this.silenceBeforeInSeconds,
        silence_after: this.silenceAfterInSeconds,
      };

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitLadda = Ladda.create(
            document.querySelector(".btn-clip-create"),
          );
          this.submitLadda.start();
          axios
            .post("/api/v1/clip", form_data)
            .then((response) => {
              this.from = "00:00:00";
              this.to = "00:00:00";
              this.silenceBefore = "00:00:00";
              this.silenceAfter = "00:00:00";
              this.errors.clear();
              if (response.data.data.message) {
                toastr.success("Your clip has been added to a queue. The below table will update once your clip has been processed.");
              }
            })
            .catch((error) => {
              window.handleAxiosError(error, 'Unable to create clip');
              this.submitLadda.stop();
            })
            .then(() => {
              this.submitLadda.stop();
              this.errors.clear();
            });
        } else {
          this.submitLadda.stop();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
    .control-label {
        text-align: right;
    }

    .clips-portlet {
        margin-top: 20px;
        padding: 0 20px 0 20px;
        border: 1px solid #ddd;
        background: #fafafa;

        .portlet-title {
            margin-top: 10px;
            border-bottom: none;
        }

        .portlet-body {
            display: none;
        }

        .btn-clip-create {
            margin-top: 20px;
        }
    }

    .clip-inputs {
        .row {
            margin: 10px 0;
        }
    }

    .note-info {
        margin-bottom: 0;
    }

    .time-input {
        margin-bottom: 20px;
    }

    .clip-table {
        margin-top:2em;
    }
</style>
